import { CustomContainer, useRouter } from "../DependencyHelper";
import Image from "../image/image";
import config from "../../../config/index";
import CTAButton from "../CTAButton/CTAButton";
import labels from "../../../config/labels";
import { showSpinner } from "../../../utils/helperServices";
import styles from "./PendingOrder.module.scss";
import * as Analytics from "../../../services/analyticsUtag";



const PendingOrder = ({ className }) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const router = useRouter();

  const viewOrderHistory = () => {
    showSpinner();
    router.push(`${urlPrefix}/view-order-history`);
    const analyticsData = {
      sales_event: "view order",
      page_name: "shopping: cart: view order",
      page_channel: "shopping",
      page_master_tab: "personal",
      link_type : "o",
      link_name : "shopping: cart: view order", 
      ...Analytics.getUtagData([
        "visitor_login_status",
        "visitor_subscription_type",
        "visitor_msisdn_hash",
        "visitor_id_hash",
      ]),
    };
    Analytics.link(analyticsData);
  };

  const RenderBox = classStyle => {
    return (
      <CustomContainer className={`${classStyle} position-relative`}>
        <Image
          img_path={`${imagePrefix}/assets/images/bundles.svg`}
          img_width="3.75rem"
          img_height="3.75rem"
        />
        <span className={styles.alertCircle}>!</span>
      </CustomContainer>
    );
  };

  return (
    <CustomContainer className={`${styles.orderRemainder} ${className}`}>
      <CustomContainer className="d-flex">
        {RenderBox("d-none d-sm-block mr-m")}
        <CustomContainer>
          <CustomContainer className={styles.imageTextBox}>
            <CustomContainer>
              {RenderBox("d-flex d-sm-none mr-s")}
            </CustomContainer>
            <div className={styles.context}>{labels.lbl_order_waiting}</div>
          </CustomContainer>
          <div className={styles.subContext}>{labels.lbl_order_not_final}</div>
          <CustomContainer className={styles.timerBox}>
            <Image
              img_path={`${imagePrefix}/assets/images/clock.svg`}
              img_width="1rem"
              img_height="1rem"
            />
            <span className={styles.timerText}>{labels.lbl_hurry_text}</span>
          </CustomContainer>
        </CustomContainer>
      </CustomContainer>
      <CustomContainer className={styles.buttonContainer}>
        <CTAButton
          className={`roundBtn mt-l ${styles.buttonStyle}`}
          variant="solid black"
          handleClick={() => viewOrderHistory()}
        >
          {labels.lbl_view_order}
        </CTAButton>
      </CustomContainer>
    </CustomContainer>
  );
};

export default PendingOrder;
